import { Box } from '@mui/joy';

/**
 * Пустое состояние раздела.
 *
 * Раньше на месте пустого списка была одна серая строка текста — экран
 * выглядел сломанным. Теперь понятная плашка: иконка, что произошло и что
 * с этим делать.
 *
 *   <EmptyState icon={<FavoriteRoundedIcon />} title="..." text="..." action={<button/>} />
 */
export default function EmptyState({ icon, title, text, action }) {
    return (
        <Box className="lvc-empty lvc-in">
            {icon ? (
                <div className="lvc-empty__icon" aria-hidden="true">
                    <Box sx={{ display: 'grid', placeItems: 'center', fontSize: 38, color: 'inherit', '& svg': { fontSize: 38, color: 'inherit' } }}>
                        {icon}
                    </Box>
                </div>
            ) : null}

            <h3 className="lvc-empty__title">{title}</h3>
            {text ? <p className="lvc-empty__text">{text}</p> : null}
            {action ? <Box sx={{ mt: 2.5 }}>{action}</Box> : null}
        </Box>
    );
}
